import { OnSaleEventsContextProvider } from 'src/contexts/OnSaleEventsContext/OnSaleEventsContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { OnSaleEventPageContentMapAndMetricsWrapper } from 'src/navigations/Routes/OnSaleEvent/OnSaleEventPage';
import { Feature } from 'src/WebApiController';

export const InventoryEventDiscoverySection = ({
  eventId,
}: {
  eventId: number;
}) => {
  const hasEventDiscoveryInInventoryViewFeature = useUserHasFeature(
    Feature.EventDiscoveryInInventoryView
  );
  return (
    <OnSaleEventsContextProvider
      eventId={eventId}
      disabled={!hasEventDiscoveryInInventoryViewFeature}
    >
      <OnSaleEventPageContentMapAndMetricsWrapper tabView eventId={eventId} />
    </OnSaleEventsContextProvider>
  );
};
